/**
 * Created by lycheng on 2017/11/23.
 * 登陆相关的方法
 */
import 'babel-polyfill'
import * as userApi from 'js/api/user'
import { toThousands, appendIframe, getQueryString } from 'js/libs/utils'
import SSO from 'js/libs/sso/sso'
import { cookie } from 'js/libs/utils-cookie'
import { layer } from 'js/libs/utils-layer'
import { config } from 'config'
import { Base64 } from 'js-base64'
import GetUserHtml from 'js/libs/utils-login-html'

const userInfoModal = new GetUserHtml()
let userinfoJson = {} // 提升为全局变量

function showLoginModal () {
  // 跳转到统一登录
  window.location.href = `${config.PASSPORT_NEW}login?jump=${Base64.encode(window.location.href)}`
}

function showRegisterModal () {
  window.location.href = `${config.PASSPORT_NEW}register?jump=${Base64.encode(window.location.href)}`
}

function closeLoginModal () {
  layer.close('.modal-wrapper-login')
  resetLoginForm()
  otherLoginCookieOperate.end()
}

function clearOtherLoginJump () {
  cookie.clear('otherLoginJump', ';path=/')
  cookie.clear('otherLoginJump', ';path=/;domain=voicecloud.cn')
}

clearOtherLoginJump()
// 第三方登陆
var otherLoginCookieOperate = {
  st: 0,
  start: function () {
    var otherLoginJump
    this.st = setInterval(function () {
      otherLoginJump = cookie.get('otherLoginJump')
      if (otherLoginJump) {
        clearOtherLoginJump()
        window.location.href = otherLoginJump
      }
    }, 100)
  },
  end: function () {
    if (this.st) {
      clearInterval(this.st)
    }
  }
}

function resetLoginForm () {
  $('#ssologin_form').get(0).reset()
  $('#login_error_tip').text('')
  $('#form_captcha').hide()
  $('#is_act').change()
  $('#register_error_tip').text('')
  $('#loginpwd_error_tip').text('')
  $('#account_login_error_tip').text('')
  $('.error-tip').text('')
  $('.modal-wrapper-register input[type="text"]').val('')
  $('.modal-wrapper-register input[type="password"]').val('')
  $('.logo-error').hide()
  $('#privacy_policy').hide()
  $('.modal-wrapper-logo').show()
}

function toLogout () {
  SSO.logout(function () {
    window.location.reload()
  })
}

// 统一登陆老系统下需要再次发送一个请求用于登陆
function ssoLoginForOldSystem () {
  appendIframe(`${config.API}api/ajaxLogin`)
}

// 宙斯老页面挑战门户首页登录
function judgeZenusLogin () {
  if (getQueryString('jump') === 'login') {
    showLoginModal()
  }
}
/**
 * 渲染用户信息，如果没有登陆则不做操作
 */
function renderUserinfo () {
  userApi.getUserinfo().then(function (result) {
    if (result.code === '0' || result.code === 0) {
      // 统一登陆老系统下需要再次发送一个请求用于登陆
      ssoLoginForOldSystem()
      let userinfo = result.data

      switch (userinfo.certificateType) {
        case 'PERSONAL': {
          userinfoJson.certificate = '个人认证'
          break
        }
        case 'STUDENT': {
          userinfoJson.certificate = '学生认证'
          break
        }
        case 'BUSINESS_TEAM': {
          userinfoJson.certificate = '创业团队认证'
          break
        }
        case 'COMPANY': {
          userinfoJson.certificate = '企业认证'
          break
        }
        default: {
          userinfoJson.certificate = '未实名认证'
        }
      }
      if (userinfo.certificateStatus === null) {
        var comRegTime = ''
        var comToday = ''
        var registrationTime = userinfo.registrationTime
        var regTime = new Date(registrationTime).toLocaleDateString()
        if (regTime.length < 15) {
          if (window.ActiveXObject) {
            comRegTime = regTime.replace(/([\d]{4})[\s\S]{1}([\d]{1,2})[\s\S]{1}([\d]{1,2})[\s\S]{1}/, '$1/$2/$3')
          } else {
            comRegTime = regTime
          }
        } else {
          comRegTime = regTime.replace(/[\s\S]{1}([\d]{4})[\s\S]{3}([\d]{1,2})[\s\S]{3}([\d]{1,2})[\s\S]{2}/, '$1/$2/$3')
        }
        var today = new Date().toLocaleDateString()
        if (today.length < 15) {
          if (window.ActiveXObject) {
            comToday = today.replace(/([\d]{4})[\s\S]{1}([\d]{1,2})[\s\S]{1}([\d]{1,2})[\s\S]{1}/, '$1/$2/$3')
          } else {
            comToday = today
          }
        } else {
          comToday = today.replace(/[\s\S]{1}([\d]{4})[\s\S]{3}([\d]{1,2})[\s\S]{3}([\d]{1,2})[\s\S]{2}/, '$1/$2/$3')
        }
      }
      if (userinfo.certificateType) {
        switch (userinfo.certificateStatus) {
          case 0:
          case '0': {
            userinfoJson.certificate = '实名认证未通过'
            break
          }
          case 2:
          case '2': {
            userinfoJson.certificate = '实名认证审核中'
            break
          }
        }
      }
      if (userinfo.certificateType) {
        userinfoJson.toCertificate = `${config.CONSOLE}user/authentication`
        if (userinfo.certificateStatus != 0 && userinfo.certificateStatus != 2) { // eslint-disable-line
          userinfoJson.certificateClass = 'certificated'
        }
      } else {
        userinfoJson.toCertificate = `${config.CONSOLE}user/authentication`
        userinfoJson.certificateClass = ''
      }
      userinfoJson.userName = userinfo.nickname || userinfo.email || userinfo.login
      userinfoJson.email = userinfo.email
      userinfoJson.certificateType = userinfo.certificateType
      userinfoJson.balance = userinfo.balance + ''
      let balanceLength = userinfoJson.balance.length
      userinfoJson.balance =
        toThousands(userinfoJson.balance.substr(0, balanceLength - 2)) +
        '.' +
        userinfoJson.balance.substr(balanceLength - 2, balanceLength)
    } else {
      judgeZenusLogin()
    }
  })
}

function init () {
  let isEnter = false
  $('body').delegate('.header-userinfo', 'mouseenter', function () {
    if (isEnter) return
    userInfoModal.hoverCallBack(function () {
      isEnter = true
      var html = userInfoModal.renderHtml(userinfoJson)
      $('.header-right').html(html).find('.login-register').remove()
    })
  })
  $('.header').on('click', '.to-logout', function () {
    toLogout()
  }).on('click', '.to-login-modal', function () {
    showLoginModal()
  }).on('click', '.to-register', function () {
    showRegisterModal()
  })

  $('.header').on('click', '.certi-every', function () {
    window.open($(this).attr('elink'))
  })

  $('.login-success-box .close-login-success').click(function () {
    $('.login-success-box').hide()
  })

  $('.modal-wrapper-login .modal-close').click(function () {
    closeLoginModal()
  })
  $('.login-other-link').click(function () {
    window.open(`${config.PASSPORT}notice/offlineOtherLogin`)
    otherLoginCookieOperate.end()
  })
  renderUserinfo()
}

init()

export {
  showLoginModal,
  closeLoginModal,
  toLogout,
  init
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-login.js